import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const EcontextProcess = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
  const paramTid = new URLSearchParams(searchParams).get('tid');
  const approvalNo = new URLSearchParams(searchParams).get('approvalNo');
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    if (paramPayUrl) {
      setIsIframe(true);
    }
  }, []);

  return (
    <>
      {isIframe && paramPayUrl && (
        <IframeContainer>
          <iframe width="100%" height="100%" src={paramPayUrl}></iframe>
          <XBtn
            onClick={() => {
              if (paramTid) {
                setIsIframe(false);
                navigate(
                  `/pc/econtext/result?tid=${paramTid}&payUrl=${paramPayUrl}&approvalNo=${approvalNo}`,
                );
              }
            }}
          >
            x
          </XBtn>
        </IframeContainer>
      )}
    </>
  );
};

export default EcontextProcess;

const IframeContainer = styled.div`
  width: 1000px;
  height: 100vh;
  position: relative;
  margin: 0 auto;
  @media only screen and (max-width: 1000px) {
    width: 100vw;
  }
`;

const XBtn = styled.button`
  position: absolute;
  z-index: 10;
  top: 20px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  cursor: pointer;
`;
